import set from "@rill/set";
import { getSessionValue } from "../../../utils/session-helper";
import ImportMealPlan from "./import-meal-plan";

const importMealPlanController = (app) => {
  app
    .use(set("heading", ["Admin", "Import Meal Plan"]))
    .get("/import-meal-plan", ({ locals, res, session }) => {
      locals.importResult = getSessionValue(session, "adminImportMealPlan");
      res.body = <ImportMealPlan />;
    })
    // Linked with `download`, so the browser fetches it directly (rill skips
    // download links) and saves the coach's meal library for Claude.
    .get("/import-meal-plan/library", async ({ api, req, res }) => {
      const email = req.query.coachEmail || "";
      let data;
      try {
        const response = await api(
          `admin-coach-meal-library?email=${encodeURIComponent(email)}`
        );
        data = await response.json();
      } catch (err) {
        // the api helper throws on a non-ok response; answer with JSON so the
        // page can show the message instead of saving an error page
        res.headers["Content-Type"] = "application/json; charset=utf-8";
        res.status = err.status ?? 500;
        res.body = JSON.stringify({
          error: {
            message:
              err.name === "HttpError"
                ? err.message
                : "Could not load the library",
          },
        });
        return;
      }

      res.headers["Content-Type"] = "application/json; charset=utf-8";
      const filename = `${data.coachEmail.replace(/[^\w.@-]/g, "_")}-meal-library.json`;
      res.headers["Content-Disposition"] = `attachment; filename="${filename}"`;
      res.body = JSON.stringify(data, null, 2);
    });
};

export default importMealPlanController;
